// extracted by mini-css-extract-plugin
var _1 = "StakingPageStyle-module__back___LDgGV";
var _2 = "StakingPageStyle-module__link-holder___SNzv2";
var _3 = "StakingPageStyle-module__link-holder___SNzv2";
var _4 = "StakingPageStyle-module__section___AQ7Gj";
var _5 = "StakingPageStyle-module__stakingPage___QVOYl";
export { _1 as "back", _2 as "link-holder", _3 as "linkHolder", _4 as "section", _5 as "stakingPage" }
